import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[lang]/stripe/page.tsx");
